import { Flex, type FlexProps, mergeSx, Skeleton, type SxPropsWithTheme, Text } from '../';
import { InfoStatsRow, type InfoStatsRowProps } from '../info-stats-row';

export interface TotalSummaryCardProps extends Omit<FlexProps, 'children'> {
  icon: JSX.Element;
  label: string;
  value: string;
  statItems: InfoStatsRowProps['statItems'];
  loading?: boolean;
  slotProps?: {
    iconContainer?: {
      sx?: SxPropsWithTheme;
    };
    labelContainer?: {
      sx?: SxPropsWithTheme;
    };
  };
}

export default function TotalSummaryCard(props: Readonly<TotalSummaryCardProps>) {
  const {
    icon,
    label,
    value,
    statItems,
    loading: isLoading = false,
    slotProps = {},
    sx,
    ...rest
  } = props;
  const iconContainerSxProp = slotProps.iconContainer?.sx;
  const labelContainerSxProp = slotProps.labelContainer?.sx;

  return (
    <Flex
      sx={mergeSx(
        (theme) => ({
          flexDirection: 'column',
          gap: theme.spacing(4),
          border: `1px solid ${theme.palette.grey[300]}`,
          p: theme.spacing(4),
          borderRadius: theme.shape.rounded(2),
        }),
        sx,
      )}
      {...rest}
    >
      <Flex
        sx={(theme) => ({
          gap: theme.spacing(4),
          alignItems: 'center',
          flexWrap: 'wrap',
        })}
      >
        <Flex
          sx={mergeSx(
            {
              padding: (theme) => theme.spacing(2),
              justifyContent: 'center',
              alignItems: 'center',
              borderRadius: (theme) => theme.shape.rounded(2),
            },
            iconContainerSxProp,
          )}
        >
          {icon}
        </Flex>
        <Flex
          sx={mergeSx(
            (theme) => ({ gap: theme.spacing(1), flexDirection: 'column' }),
            labelContainerSxProp,
          )}
        >
          <Text>{label}</Text>
          <Text variant='h3'>{isLoading ? <Skeleton /> : value}</Text>
        </Flex>
      </Flex>
      <InfoStatsRow loading={isLoading} statItems={statItems} />
    </Flex>
  );
}
